import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Renderer2, TemplateRef, ChangeDetectionStrategy, inject, signal, viewChild } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import { ShareReportModalComponent } from '@app/modules/statistics/share-report-modal/share-report-modal.component';
import {Campaign, InfluencerType, ReportConversionsBySegment, ReportInfluencers, ReportModel, ReportTotals} from '@app/modules/shared/models';
import {select, Store} from '@ngrx/store';
import {
  CampaignGetAll, getCampaigns,
  getInfluencerError, getInfluencersProjectSegment,
  getInfluencersTypes, getLoggedInUser, getProjects,
  getReport,
  getReportError, getReportPassword, IAuthenticationState, ICampaignState,
  IInfluencersState, InfluencersExport, InfluencersProjectSegment,
  InfluencersTypeList, IProjectState,
  IReportState, Report, ReportPassword, ResetReportState, ProjectsReportExport, UploadToSignedUrl,
  IFileUploadState,
  getFileUploadProgress, getUploadToSignedUrl, ReportAdvocatesExport
} from '@app/stores';
import {Subject, BehaviorSubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import moment from 'moment-timezone';
import {NgbDropdown, NgbDropdownMenu, NgbDropdownToggle, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TimeToRegisterFilterComponent} from '@app/_components/time-to-register-filter/time-to-register-filter.component';
import {parseTimeToRegister, timeToRegisterLabel} from '@app/_helpers/time-to-register';
import { SbDateRange, SbInputDateRangeComponent } from '@app/_components/unified/sb-date-time/sb-input-date-range.component';
import { SbRangePresetId } from '@app/_components/unified/sb-date-time/sb-quick-picks';
import { TzDatePipe } from '@app/modules/shared/pipes/tz-date.pipe';
import {AwsService} from '@app/services/aws.service';
import {SocketService} from '@app/services/socket.service';
import {ReportAccessTokenService} from '@app/services/report-access-token.service';
import {ImpressionService} from '@app/services/impression.service';
import {SbTableComponent} from '@app/_components/unified/sb-table/sb-table.component';
import {SbTableCellDirective} from '@app/_components/unified/sb-table/sb-table.directives';
import {SbTableColumn, SbTableOptions, SbTableServerState} from '@app/_components/unified/sb-table/sb-table.types';
import {TrackingAccuracyModalComponent} from '@app/modules/statistics/tracking-accuracy-modal/tracking-accuracy-modal.component';
import { PageShellComponent } from '../../../_components/page-shell/page-shell.component';
import { CreatableSelectComponent } from '../../../_components/creatable-select/creatable-select.component';
import { InfoPopoverComponent } from '../../../_components/info-popover/info-popover.component';
import {escapeHtmlText} from '@app/_components/unified/sb-rich-text/rich-text-html';
import { DatePipe } from '@angular/common';
import { SbTabsComponent } from '../../../_components/unified/sb-tabs/sb-tabs.component';
import { SbTabDirective } from '../../../_components/unified/sb-tabs/sb-tab.directive';
import { ReportConversionsComponent } from '../report-conversions/report-conversions.component';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { ChartComponent } from 'ng-apexcharts';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TzDatePipe as TzDatePipe_1 } from '../../shared/pipes/tz-date.pipe';
import {SbModalService} from '@app/_components/unified/sb-modal/sb-modal.service';

declare let vis: any;

/** An advocates table column; it sorts by `sortKey` where the report knows it by another name than its id. */
export type ReportTableColumn = SbTableColumn & {sortKey?: string};

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageShellComponent, CreatableSelectComponent, SbInputDateRangeComponent, InfoPopoverComponent, SbTabsComponent, SbTabDirective, ReportConversionsComponent, MatMenuTrigger, MatMenu, SbTableComponent, SbTableCellDirective, ChartComponent, ReactiveFormsModule, FormsModule, DatePipe, TzDatePipe_1,
    NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, TimeToRegisterFilterComponent]
})
export class ReportComponent implements OnInit, OnDestroy, AfterViewInit {
  private renderer = inject(Renderer2);
  private activatedRoute = inject(ActivatedRoute);
  private toastr = inject(ToastrService);
  private influencerStore = inject<Store<IInfluencersState>>(Store);
  private reportStore = inject<Store<IReportState>>(Store);
  private campaignStore = inject<Store<ICampaignState>>(Store);
  private authenticationStore = inject<Store<IAuthenticationState>>(Store);
  private _modalService = inject(NgbModal);
  private readonly sbModal = inject(SbModalService);
  private router = inject(Router);
  private projectStore = inject<Store<IProjectState>>(Store);
  private tzDatePipe = inject(TzDatePipe);
  private awsService = inject(AwsService);
  private fileUploadStore = inject<Store<IFileUploadState>>(Store);
  private socketService = inject(SocketService);
  private reportAccessTokenService = inject(ReportAccessTokenService);
  private impressionService = inject(ImpressionService);
  private cdr = inject(ChangeDetectorRef);

  readonly iframe = viewChild<ElementRef>('iframe');
  readonly modalLoadReport = viewChild<ElementRef>('loadReport');
  public report: ReportModel = null;
  public reportTotals: ReportTotals = null;
  newDummyCampaign = new Campaign();
  campaigns: Campaign[] = [];
  public influencers: ReportInfluencers = null;
  public pageViews: any = null;
  public conversions: any = null;
  public projectId: number;
  public referrals: any;
  public socketSubscription: any;
  public exportJobId: number;
  series: any = [];
  dates: any = [];
  referralBy = '';
  influencerTypes: InfluencerType[] = [];
  segments: any = [];
  private unsubscriber = new Subject();
  /** The advocates on the table's page: the rows it shows. */
  readonly influencersList = signal<any[]>([]);
  _object = Object;
  socialShareString: any = '';
  public typeColor: any = [
    '#ee6baa', '#c129d3', '#f0c20a', '#4ce0ec',
    '#662ff1', '#8fe7c6', '#eb2764', '#c11408',
    '#5b9f42', '#4f1573', '#851e42', '#0de3ca',
    '#c4c0e8', '#099a91', '#1c34a8', '#2e150c'];
  private firstTime = true;
  private networkGraph;
  private scaleFactor = 0.1;
  public influencerTypeId: any = null;
  /** The Conversions tab only: conversions that took less than this many seconds from the click; null for all. */
  timeToRegisterLt: number | null = null;
  readonly timeToRegisterLabel = timeToRegisterLabel;
  public selectedSegment: any = null;
  public startDate = '';
  public endDate = '';
  /** An empty bound already means "from the first impression" / "to the last", so All time is offered. */
  readonly reportPresets: readonly SbRangePresetId[] = [
    'today', 'yesterday', 'last7Days', 'last14Days', 'last30Days', 'last90Days',
    'thisWeek', 'lastWeek', 'thisMonth', 'lastMonth', 'thisQuarter', 'lastQuarter', 'yearToDate', 'last12Months', 'allTime',
  ];
  public justSetDate = true;
  /** The dates the address names, as last seen. */
  private addressDates: {startDate: string | null; endDate: string | null} = {startDate: null, endDate: null};
  /**
   * The dates the page has just put in the address, until that change is seen: a side that change
   * leaves out is open, and keeps the first or last impression's date the report filled in.
   */
  private ownDates: {startDate: string | null; endDate: string | null} | null = null;
  public showAllColumns = false;
  /** The advocates table's columns; those the report can sort by sort descending first. */
  public readonly tableColumns: ReportTableColumn[] = this.buildTableColumns();
  public readonly tableOptions: SbTableOptions = {
    serverSide: true,
    selectable: false,
    pageLength: 10,
    lengthChange: false,
    defaultSort: {columnId: 'referred_count', direction: 'desc'},
    // No label above the box: its placeholder says what it searches.
    searchLabel: null,
    searchPlaceholder: 'Search name, email, company, etc',
    emptyMessage: 'No data found',
    // Pins are kept per table id: its own, so that pins made on another list do not come here.
    tableId: 'report-advocates',
    fixedRight: 0,
  };
  /** The advocates across all pages, for the table's pager. */
  readonly totalRows = signal(0);
  /** The table first asks for the report once it may be read (signed in, or after the password). */
  readonly tableStarted = signal(false);
  public projects = [];
  public selectedProject = null;
  public selectedChk: any = {all: false};
  public selectedInfluencerTypes: any = {all: false};
  public referralIds = null;
  setStartDate: any;
  setEndDate: any;
  refreshData = null;
  campaignId = null;
  mode = 'live';
  modes = [
    {
      name: 'Live Data',
      id: 'live'
    },
    {
      name: 'Test Data',
      id: 'test'
    }
  ];
  readonly currentUser = signal<any>(undefined);
  hideDiv = {
    socialShare: false,
    emailEngagement: false,
    landingPageViews: false,
    conversions: false,
    conversionsBySegment: false,
    conversionsByCampaignType: false,
    preferenceInsights: false,
    summary: false,
    shareMediaTypes: false,
    sharesByCountry: false
  };
  preferenceInsightsChart = {
    series: [],
    categories: [],
    colors: ['#00A8EC', '#fd7e14', '#dc3545', '#e83e8c', '#6f42c1', '#333399', '#28a745'],
    annotations: {xaxis: []},
    xMin: null,
    xMax: null,
    markerTitles: []
  };
  showCampaignLaunchLabels = true;
  selectedSocialNetwork: string | null = null;
  readonly passwordForm = viewChild<TemplateRef<any>>('passwordForm');
  // The password dialog and the export dialog are views of their own, outside this one: what
  // they show is in signals.
  readonly reportPassword = signal('');
  readonly reportPasswordError = signal('');
  temporaryToken = '';
  reportPasswordClick = false;
  readonly reportPasswordPending = signal(false);
  reportModel: any;
  passwordModalRef: any;
  conversionsGraph = {
    dataLabels: {},
    xaxis: {},
    yaxis: {},
    tooltip: {},
    series: [],
  };
  piechart: any = {
    labels: [],
    series: [],
    colors: [],
    tooltip: {},
    dataLabels: {
      enabled: true,
      textAnchor: 'middle',
      formatter: (val, opts) => [opts.w.config.labels[opts.seriesIndex], val.toFixed(1) + '%'],
      style: {
        fontSize: '9px',
        fontFamily: 'Helvetica',
        colors: ['#ffffff']
      },
      dropShadow: {
        enabled: false
      }
    },
    chart: {
      type: 'pie',
      height: '450',
      events: {}
    }
  };
  conversionsBySegmentPie: any = this.conversionsPie([]);
  conversionsByCampaignTypePie: any = this.conversionsPie([]);
  radialBar: any = {
    series: [],
    colors: [],
    labels: [],
    legend: {},
    stroke: {},
    plotOptions: {},
    responsive: []
  };
  shareMediaRadialBar: any = {
    series: [],
    colors: [],
    labels: [],
    legend: {},
    plotOptions: {},
    responsive: []
  };
  readonly sharesMapElement = viewChild<ElementRef>('sharesMap');
  sharesMap: any = null;
  hasSharesByCountry = false;
  // Countries too small for the world map (Singapore, Bahrain, ...), listed under it instead.
  sharesNotOnMap: {name: string, count: number}[] = [];
  private readonly onSharesMapResize = () => this.sharesMap?.updateSize();
  socialNetworkColors: any = {
    facebook: '#1877F2',
    linkedin: '#0A66C2',
    twitter: '#00DBF7',
    sms: '#FF9800', // orange (good contrast in charts)
    mail: '#EA4335',
    email: '#EA4335',
    whatsapp: '#25D366',
    slack: '#8B5CF6',
    google: '#4285F4',
    instagram: '#E4405F',
    facebook_messenger: '#0099FF',
    microsoft_teams: '#6264A7',
    zalo: '#0068FF',
    line: '#00C300',
    viber: '#8F5DB7',
    wechat: '#07C160',
    telegram: '#24A1DE',
    signal: '#3A76F0',
    tiktok: '#FE2C55',
    vk: '#4C75A3',
    bluesky: '#1185FE'
  };
  socialNetworkDisplayNames: any = {
    facebook: 'Facebook',
    twitter: 'X',
    linkedin: 'LinkedIn',
    whatsapp: 'WhatsApp',
    slack: 'Slack',
    instagram: 'Instagram',
    email: 'Email',
    facebook_messenger: 'Facebook Messenger',
    microsoft_teams: 'Microsoft Teams',
    sms: 'SMS',
    zalo: 'Zalo',
    line: 'LINE',
    viber: 'Viber',
    wechat: 'WeChat',
    telegram: 'Telegram',
    signal: 'Signal',
    tiktok: 'TikTok',
    vk: 'VK (Vkontakte)',
    bluesky: 'Bluesky',
    google: 'Google'
  };
  influencerTypesById: any = {};
  groupTypeColor: any = {
    attendees: '#4ab8e3',
    speakers: 'rgb(254, 176, 25)',
    partners: 'rgb(0, 227, 150)',
    campaigns: 'rgb(26,255,0)',
  };
  selectedFromList: any = null;
  _moment = moment;
  chkTimeout = null;
  forceGroup = false;
  isTableHide = false;
  influencerFrontList: any[] = [];
  currentProject: any;
  projectStartDate: any;
  projectEndDate: any;
  loadReport: any;
  isReportLoading = true;
  loadModalReportRef: any;
  isStartDateNull = false;
  isEndDateNull = false;
  readonly csvDownloadComplete = signal(false);
  exportModelRef: any;
  modelOpen = false;
  csvUrl: any;
  uniqueImportString: any;
  exportProcess = false;
  public readonly exportProgress = signal<any>({
    status: 'started',
    remainingTimeFormatted: '',
    elapsedTimeFormatted: '',
    progress: 0
  });
  fileName: any;
  fileResponse: any[] = [];
  // Charts is everything the report showed before; Conversions is who referred whom.
  activeReportTab = 'charts';
  // The export the progress modal follows: the advocates' or the conversions'.
  exportRequesterType = 'project_report_advocates_export';

  blobObject: any;

  readonly csvDownload = viewChild<TemplateRef<any>>('csvDownload');
  public loaderImport = new BehaviorSubject<boolean>(false);
  constructor() {
    this.newDummyCampaign.id = -1;
    this.newDummyCampaign.name = 'All';
    this.campaigns = [this.newDummyCampaign];
    this.campaignId = -1;
    this.authenticationStore.pipe(select(getLoggedInUser))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(user => {
        if (user) {
          this.currentUser.set(user);
        }
      });
    this.reportStore.dispatch(ResetReportState({params: {report: null, error: '', reportPassword: ''}}));
    this.subscribeStore();
    this.subscribeToSocket();

  }

  subscribeStore() {
    this.influencerStoreSubscribe();
    this.reportStoreSubscribe();
    this.campaignStoreSubscribe();
    this.fileStoreSubscribe();
  }

  setCurrentSelectedProject() {
    if (this.projectId && this.projects) {
      if(this.selectedFromList) {
        this.selectedFromList = null;
        this.referralIds = null;
        this.isTableHide = false;
      }
      this.isStartDateNull = false;
      this.isEndDateNull = false;
      this.selectedProject = this.projects.find(x => Number(x.id) === Number(this.projectId));
      this.dateEvents();
      // Called from the store, the route and a retry timer.
      this.cdr.markForCheck();
      if(this.selectedProject) {
        setTimeout(()=> {
          const iframe = this.iframe();
          const doc =  iframe.nativeElement.contentDocument || iframe.nativeElement.contentWindow;
          doc.open();
          doc.write(this.selectedProject?.report_analysis || '');
          doc.close();
        },3000);
      } else {
        setTimeout(()=> {
          this.setCurrentSelectedProject();
        },300);
      }
    }
  }

  influencerStoreSubscribe() {
    this.influencerStore.pipe(select(getInfluencerError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });
    this.projectStore.pipe(select(getProjects))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(projects => {
        if (projects) {
          this.projects = projects;
          this.setCurrentSelectedProject();
        }
      });
    this.influencerStore.pipe(select(getInfluencersTypes))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(influencerTypes => {
        if (influencerTypes && influencerTypes.length > 0) {
          this.influencerTypes = influencerTypes;
          this.selectedInfluencerTypes['all'] = this.influencerTypes.map(x => this.selectedInfluencerTypes[x.id]).filter(Boolean).length === (this.influencerTypes || []).length;
          if (!this.selectedInfluencerTypes['all'] && this.campaignId === -1) {
            this.selectedInfluencerTypes['all'] = true;
            this.influencerTypes.forEach(item => {
              this.selectedInfluencerTypes[item.id] = true;
            });
          }
          this.influencerTypes.forEach(item => {
            this.influencerTypesById[item.id] = {};
            if (item.fields) {
              Object.keys(item.fields).forEach(key => {
                this.influencerTypesById[item.id][key] = true;
              });
            }
          });
          // The type filter's choices, ticked in place.
          this.cdr.markForCheck();
        }
      });
    this.influencerStore.pipe(select(getInfluencersProjectSegment))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(segments => {
        if (segments && segments.length > 0) {
          this.forceGroup = segments.length > 3;
          this.segments = segments;
          this.selectedChk['all'] = this.segments.map(x => this.selectedChk[x.id]).filter(Boolean).length === (this.segments || []).length;
          if (!this.selectedChk['all'] && this.campaignId === -1) {
            this.selectedChk['all'] = true;
            this.segments.forEach(item => {
              this.selectedChk[item.id] = true;
            });
          }
          this.doResize();
          // The segment filter's choices, ticked in place.
          this.cdr.markForCheck();
          // this.segments = [{
          //   id: null,
          //   name: 'All'
          // }, ...segments];
        }
      });
  }

  reportStoreSubscribe() {
    this.reportStore.pipe(select(getReportError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          if (this.reportPasswordClick) {
            this.reportPasswordClick = false;
            this.reportPasswordPending.set(false);

            // Public report page (not logged in): keep the password prompt open and say
            // why inside it, rather than closing it over an empty report.
            if (!this.currentUser()) {
              this.reportPasswordError.set(error);
              return;
            }

            this.toastr.error(error, 'Error');
            if (this.reportModel) {
              this.reportModel.close();
            }
            this.router.navigate(['/login'], {queryParams: {returnUrl: this.router.url}});
            return;
          }
          // The interceptor drops the report token when the server refuses it (expired or
          // revoked), so an anonymous viewer is back to needing the password.
          if (!this.currentUser() && this.temporaryToken && !this.reportAccessTokenService.get()) {
            this.temporaryToken = '';
            this.report = null;
            this.isReportLoading = false;
            this.loadModalReportRef?.dismiss();
            this.reportPasswordError.set('Your access to this report has expired. Please enter the password again.');
            this.showPasswordForm();
            this.cdr.markForCheck();
            return;
          }
          this.toastr.error(error, 'Error');
          if (!this.currentUser()) {
            // If we fail while trying to load the report without a session, avoid infinite loader.
            this.isReportLoading = false;
            if (this.loadModalReportRef) {
              this.loadModalReportRef.dismiss();
            }
          }
        }
      });
    this.reportStore.pipe(select(getReport))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(report => {
        if (report) {
          this.report = report;
          if (this.refreshData) {
            this.reportTotals = null;
            this.pageViews = null;
            this.influencers = null;
            this.preferenceInsightsChart = {
              series: [],
              categories: [],
              colors: ['#00A8EC', '#fd7e14', '#dc3545', '#e83e8c', '#6f42c1', '#333399', '#28a745'],
              annotations: {xaxis: []},
              xMin: null,
              xMax: null,
              markerTitles: []
            };
          }
          this.refreshData = false;
          if (report.minMax) {
            this.justSetDate = true;
            if (this.isStartDateNull) {
              this.startDate = null;
              this.setStartDate = null;
            } else {
              this.startDate = this.startDate || report.minMax.firstImp;
              this.setStartDate = this.getDate(this.startDate) || null;
            }
            if (this.isEndDateNull) {
              this.endDate = null;
              this.setEndDate = null;
            } else {
              this.endDate = this.endDate || report.minMax.lastImp;
              this.setEndDate = this.getDate(this.endDate) || null;
            }
          }
          if (report.totals) {
            this.reportTotals = report.totals;
            this.generatePieChart();
            this.generateConversionsPies();
            this.generateRadialPieChart();
            this.generatePreferenceInsightsChart();
            this.generateShareMediaChart();
            this.renderSharesMap();
          }
          if (report.pageViews) {
            this.pageViews = report.pageViews;
            this.getSeries();
          }
          if (report.conversions) {
            this.conversions = report.conversions;
            this.generateConversionsGraph();
          }
          if (report.influencers) {
            if (report.influencers.list.length > 0) {
              this.influencers = report.influencers;
              this.totalRows.set(typeof report.influencers.paging.total === 'object' ? report.influencers.paging.total.length : report.influencers.paging.total);
              this.influencersList.set(report.influencers.list);
              if(!this.selectedFromList) {
                this.influencerFrontList = this.influencersList();
              }
            } else {
              this.influencers = null;
              this.influencersList.set([]);
              this.totalRows.set(0);
            }
          } else {
            this.totalRows.set(0);
          }
          if (report.referrals && report.referrals.length) {
            this.referrals = report.referrals;
            this.networkGraph = null;
            this.generateNetworkGraph(report.referrals);
          }
          if( !report.referrals && this.referrals && this.referrals.length) {
            this.generateNetworkGraph(this.referrals);
          }
          this.firstTime = false;
          // The totals, the dates and the charts' options (changed in place) were all written.
          this.cdr.markForCheck();
          setTimeout(() => {
            this.justSetDate = false;
            this.isReportLoading = false;
            this.loadModalReportRef?.dismiss();
          });
        }
      });

    this.reportStore.pipe(select(getReportPassword))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(reportPassword => {
        if (reportPassword) {
          this.reportPasswordClick = false;
          this.reportPasswordPending.set(false);
          this.reportPasswordError.set('');
          this.reportPassword.set('');
          if (this.reportModel) {
            this.reportModel.close();
          }
          this.temporaryToken = reportPassword;
          this.openLoadingModal();
          this.initData();
          // The report is no longer locked.
          this.cdr.markForCheck();
        }
      });
  }

  campaignStoreSubscribe() {
    this.campaignStore.pipe(select(getCampaigns))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(campaigns => {
        if (campaigns && campaigns.length > 0) {
          this.campaigns = [
            this.newDummyCampaign,
            ...campaigns
          ];
          this.cdr.markForCheck();
        }
      });
  }

  fileStoreSubscribe() {
    this.fileUploadStore.pipe(select(getFileUploadProgress))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((data: any) => {
        // if (data !== undefined && data !== null) {
        //   this.importProgress = {
        //     status: 'uploading',
        //     progress: data
        //   };
        //   if (data >= 100) {
        //     this.importProgress = {
        //       status: 'started',
        //       progress: 0
        //     };
        //   }
        // }
      });

    this.fileUploadStore.pipe(select(getUploadToSignedUrl))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((data: any) => {
        if (data && this.fileResponse && this.fileResponse.length > 0) {
          this.csvUrl = this.fileResponse[0]['url'].split('?')[0];
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(this.blobObject);
          a.download = this.fileName;
          a.click();
          // this.exportModelRef.close();
          this.csvDownloadComplete.set(true);
          this.setExportProgress({status: 'started', progress: '0'});
        }
      });
  }

  private setExportProgress(changes: any): void {
    this.exportProgress.update((progress) => ({...progress, ...changes}));
  }

  subscribeToSocket() {
    this.socketSubscription = this.socketService.sourceData.subscribe(
      (message: any) => {
        if (message?.data?.requesterType === this.exportRequesterType && (!this.exportJobId || message?.data?.id === this.exportJobId) && message?.data?.uniqueImportString === this.uniqueImportString) {
          if (!this.csvDownloadComplete()) {
            this.setExportProgress({status: 'started', progress: '0'});
          }
          // Set job id
          this.exportJobId = message.data.id;
          const rt = message?.data?.remainingTimeFormatted;
          this.setExportProgress({
            status: message.data?.result?.status,
            progress: message?.data?.result?.progress ? message?.data?.result?.progress : 0,
            remainingTimeFormatted: (rt && !rt.includes('NaN')) ? rt : ''
          });
          // adjust loading state for finished/failed
          const status: string = this.exportProgress()?.status;
          if (['finished', 'failed'].includes(this.exportProgress().status)) {
            setTimeout(async () => {
              this.loaderImport.next(false);
              // Keep status
              // Restart progress upon failed
              if (status === 'finished' && !this.exportProcess) {
                this.exportProcess = true;
                if (message?.data?.result?.fileUrl) {
                  this.csvUrl = message?.data?.result?.fileUrl;

                  // Download export file
                  await this.downloadExportFile();

                  this.csvDownloadComplete.set(true);
                  this.setExportProgress({status: 'started', progress: '0'});
                }
                this.exportJobId = null;
              }
              if (status === 'failed') {
                this.csvDownloadComplete.set(false);
                this.exportJobId = null;
              }
            }, 1500);
          }
        }
      },
      (err) => console.error(err),
      () => console.warn('Completed!')
    );
  }

  async downloadExportFile() {
    const fileName = this.csvUrl.split('/').pop();
    const response = await fetch(this.csvUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }

  getSignedUrlFromFile(file) {
    return new Promise((resolve, reject) => this.awsService.getAwsSignedUrl(file.name, file.type, true).subscribe((resp: any) => {
      resolve({
        url: resp.data.url,
        fileData: file
      });
    }, reject));
  }



  shareReport() {
    // this.loader$ = null;
    this.sbModal.openComponent(ShareReportModalComponent, {
      centered: false,
      size: 'lg',
      keyboard: true,
    }, {
      projectId: this.projectId,
      selectedProject: this.selectedProject,
    });
  }

  trackingAccuracy() {
    const modelRef = this.sbModal.openComponent(TrackingAccuracyModalComponent, {
      centered: false,
      size: 'lg',
      keyboard: true,
    }, {
      projectId: this.projectId,
    });

    modelRef.result.then((result) => {
      if(result) {
        this.getImpressions();
      }
    });
  }

  showColumns(event) {
    this.showAllColumns = event.target.checked;
    this.doResize();
  }

  changeChk(type, event) {
    if(this.selectedFromList) {
      this.selectedFromList = null;
      this.referralIds = null;
      this.isTableHide = false;
    }
    this.selectedChk[type] = event.target.checked;
    if (type === 'all') {
      (this.segments || []).forEach(item => {
        this.selectedChk[item.id] = event.target.checked;
      });
    } else {
      const sync = {...this.selectedChk};
      delete sync['all'];
      this.selectedChk['all'] = Object.values(sync).filter(Boolean).length === (this.segments || []).length;
    }
    let ids = null;
    if (!this.selectedChk['all']) {
      ids = [];
      (this.segments || []).forEach(item => {
        if (this.selectedChk[item.id]) {
          ids.push(item.id);
        }
      });
      ids = ids.length ? ids : null;
    }
    if (this.chkTimeout) {
      clearTimeout(this.chkTimeout);
    }
    this.chkTimeout = setTimeout(() => {
      this.segmentSelected(ids);
      this.chkTimeout = null;
      this.cdr.markForCheck();
    }, 1000);
  }


  changeInfluencerType(type, event) {
    if(this.selectedFromList) {
      this.selectedFromList = null;
      this.referralIds = null;
      this.isTableHide = false;
    }
    this.selectedInfluencerTypes[type] = event.target.checked;
    if (type === 'all') {
      (this.influencerTypes || []).forEach(item => {
        this.selectedInfluencerTypes[item.id] = event.target.checked;
      });
      this.startDate = null;
      this.endDate = null;
    } else {
      const sync = {...this.selectedInfluencerTypes};
      delete sync['all'];
      this.selectedInfluencerTypes['all'] = Object.values(sync).filter(Boolean).length === (this.influencerTypes || []).length;
    }
    let ids = null;
    if (!this.selectedInfluencerTypes['all']) {
      ids = [];
      (this.influencerTypes || []).forEach(item => {
        if (this.selectedInfluencerTypes[item.id]) {
          ids.push(item.id);
        }
      });
      ids = ids.length ? ids : null;
    }
    if (this.chkTimeout) {
      clearTimeout(this.chkTimeout);
    }
    this.chkTimeout = setTimeout(() => {
      this.influencerTypesSelected(ids);
      this.chkTimeout = null;
      this.cdr.markForCheck();
    }, 1000);
  }

  exportData() {
    // this.influencerStore.dispatch(InfluencersExport());
  }

  showAllInfluencers() {
    this.referralIds = null;
    this.selectedSocialNetwork = null;
    if(this.selectedFromList.referredBy) {
      this.showFrontData(this.selectedFromList.referredBy);
      this.isTableHide = false;
    } else {
      this.isTableHide = false;
      this.selectedFromList = null;
    }
    this.getImpressions('influencers', undefined, undefined, '');
  }

  showFrontData(referralId) {
    this.referralIds = referralId;
    // this.selectedFromList = this.influencersList.filter(x => x.id === referralId);
    this.influencerFrontList.forEach(x => {
      if(x.id === referralId) {
        this.selectedFromList = x;
      }
    });
    this.selectedSocialNetwork = null;
    // this.getImpressions('influencers', undefined, undefined, '');
  }

  getEmailOpenRatePercentage(record) {
    if (record && record.emailsOpenRate) {
      if (record.emailsOpenRate.opened > 0 && record.emailsOpenRate.sent) {
        return ((record.emailsOpenRate.opened / record.emailsOpenRate.sent) * 100).toFixed(2);
      }
      return 0;
    } else {
      return 0;
    }
  }

  getEmailClickRatePercentage(record) {
    if (record && record.emailsOpenRate) {
      if (record.emailsOpenRate.clicked > 0 && record.emailsOpenRate.sent > 0) {
        return ((record.emailsOpenRate.clicked / record.emailsOpenRate.sent) * 100).toFixed(2);
      }
      return 0;
    } else {
      return 0;
    }
  }

  getCTARatePercentage(record) {
    // Views leave out skipped landing pages, so their automatic redirects leave the rate too.
    const clicks = record?.registrationClicksManual ?? record?.registrationClicks;
    if (record && clicks) {
      if (clicks > 0 && record.pageViews > 0) {
        return ((clicks / record.pageViews) * 100).toFixed(2);
      }
      return 0;
    } else {
      return 0;
    }
  }

  getReferralsRatePercentage(record) {
    if (record && record.referrals.all) {
      if (record.referrals.all > 0 &&  record.registrationClicks > 0) {
        return ((record.referrals.all / record.registrationClicks) * 100).toFixed(2);
      }
      return 0;
    } else {
      return 0;
    }
  }

  formatRoi(totals: any): string {
    const amount = totals?.registerAveragePrice >= 0
      ? totals.registerAveragePrice * (totals?.referrals?.all || 0)
      : 0;
    const currency = totals?.currency || 'USD';
    try {
      return new Intl.NumberFormat('en-US', {style: 'currency', currency}).format(amount);
    } catch {
      return `${currency} ${amount.toFixed(2)}`;
    }
  }

  ngOnInit() {
    // this.loadReport = document.getElementById('loadReport');
    this.openLoadingModal();
    this.activatedRoute.params.subscribe(params => {

      if (params.projectId) {
        this.projectId = params.projectId;
        this.cdr.markForCheck();
      }
    });
    if (this.currentUser()) {
      this.initData();
    } else {
      this.activatedRoute.params.subscribe(p => {
        this.projectId = +p.projectId;
        this.setCurrentSelectedProject();
        this.showPasswordForm();

        this.selectedProject = this.projects.find(x => Number(x.id) === Number(this.projectId));
      });
    }
    this.initResize();
  }

  openLoadingModal() {
    if (this.loadModalReportRef) {
      return;
    }
    const ref = this._modalService.open(this.modalLoadReport(), {
      centered: true,
      size: 'sm',
      keyboard: false,
      backdrop : 'static',
      windowClass: 'sn-content-loading-window',
      backdropClass: 'sn-content-loading-backdrop',
    });
    this.loadModalReportRef = ref;
    const forget = () => {
      if (this.loadModalReportRef === ref) {
        this.loadModalReportRef = null;
      }
    };
    ref.result.then(forget, forget);
  }

  initData() {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      const {campaignId, mode, influencerTypeId, segmentId, startDate, endDate, timeToRegisterLt} = params;
      let selectedCampaignId = null;
      let selectedInfluencerTypeId = null;
      let selectedSegmentId = null;
      let selectedStartDate = null;
      let selectedEndDate = null;

      let source = 'live';
      if (campaignId) {
        selectedCampaignId = Number(campaignId);
      }

      if (influencerTypeId) {
        selectedInfluencerTypeId = JSON.parse(influencerTypeId);
      }

      if (segmentId) {
        selectedSegmentId = JSON.parse(segmentId);
      }

      if (startDate) {
        selectedStartDate = startDate;
      }

      if (endDate) {
        selectedEndDate = endDate;
      }

      if (mode) {
        source = mode;
      }

      // Back or Forward to another date range brings dates the report is not showing: load them.
      // The datepicker reported a date set from here as a change once (ngx-bootstrap's did that,
      // and its handler loaded the report); Material's reports only the user's own pick. A pick
      // has already loaded and put its dates in the address, so they compare equal here.
      const own = !!this.ownDates && this.ownDates.startDate === selectedStartDate && this.ownDates.endDate === selectedEndDate;
      this.ownDates = null;
      this.addressDates = {startDate: selectedStartDate, endDate: selectedEndDate};
      const datesMoved = !this.justSetDate
        && ((selectedStartDate && selectedStartDate !== this.startDate) || (selectedEndDate && selectedEndDate !== this.endDate));

      this.mode = source;
      this.campaignId = selectedCampaignId || -1;
      this.influencerTypeId = selectedInfluencerTypeId;
      this.selectedSegment = selectedSegmentId;
      this.startDate = selectedStartDate ?? (own ? this.startDate : null);
      this.endDate = selectedEndDate ?? (own ? this.endDate : null);
      this.timeToRegisterLt = parseTimeToRegister(timeToRegisterLt);

      if (this.selectedSegment && this.selectedSegment.length) {
        this.selectedSegment.forEach(item => {
          this.selectedChk[item] = true;
        });
      }

      if (this.influencerTypeId && this.influencerTypeId.length) {
        this.influencerTypeId.forEach(item => {
          this.selectedInfluencerTypes[item] = true;
        });
      }
      // The filters the address names, ticked in place.
      this.cdr.markForCheck();

      if (datesMoved) {
        this.isStartDateNull = this.isStartDateNull && !selectedStartDate;
        this.isEndDateNull = this.isEndDateNull && !selectedEndDate;
        this.getImpressions(undefined, undefined, undefined, undefined);
      }
    });
    this.activatedRoute.params.subscribe(p => {
      this.projectId = +p.projectId;
      this.startDate = null;
      this.endDate = null;
      this.setCurrentSelectedProject();
      this.restartTable();
      this.getCampaignsList();
      this.influencerStore.dispatch(InfluencersTypeList({params: {influencer_fields: true}}));
      this.influencerStore.dispatch(InfluencersProjectSegment({projectId: this.projectId}));
      this.cdr.markForCheck();
    });
  }

  getCampaignsList() {
    this.campaignStore.dispatch(CampaignGetAll({filter: {project_id: this.projectId, options: JSON.stringify({include_influencer_stats: true})}}));
  }

  campaignSelected(event) {
    this.refreshData = true;
    this.campaignId = event ? event.value : null;
    if (this.campaignId > 0) {
      if (this.selectedChk['all']) {
        this.selectedChk['all'] = false;
        this.segments.forEach(item => {
          this.selectedChk[item.id] = false;
        });
        this.selectedSegment = [];
        this.influencerTypeId = [];
      }
    }
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        campaignId: this.campaignId && this.campaignId > 0 ? this.campaignId : null
      },
      queryParamsHandling: 'merge'
    });
    this.getImpressions(undefined, undefined, undefined, undefined);
  }

  segmentSelected(ids = null) {
    this.selectedSocialNetwork = null;
    this.selectedSegment = ids;
    this.influencerTypeId = null;
    // if (ids && ids.length) {
    //   this.influencerTypeId = this.segments.filter(item => ids.includes(item.id)).map(x => x.influencer_type_id);
    // }

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        // influencerTypeId: (this.selectedSegment && this.selectedSegment.length) ? JSON.stringify(this.influencerTypeId) : null,
        segmentId: (this.selectedSegment && this.selectedSegment.length) ? JSON.stringify(this.selectedSegment) : null
      },
      queryParamsHandling: 'merge'
    });

    this.getImpressions(undefined, undefined, undefined, undefined);
  }

  influencerTypesSelected(ids = null) {
    this.selectedSocialNetwork = null;
    this.selectedSegment = null;
    this.influencerTypeId = ids;
    // if (ids && ids.length) {
    //   this.influencerTypeId = this.influencerTypeId.filter(item => ids.includes(item.id)).map(x => x.influencer_type_id);
    // }

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        influencerTypeId: (this.influencerTypeId && this.influencerTypeId.length) ? JSON.stringify(this.influencerTypeId) : null,
      },
      queryParamsHandling: 'merge'
    });



    this.getImpressions(undefined, undefined, undefined, undefined);
  }

  /*segmentSelected(event) {
    this.selectedSegment = event ? event.value : null;
    this.influencerTypeId = null;
    if (event) {
      this.influencerTypeId = this.segments.find(item => item.id === event.value).influencer_type_id;
    }

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        influencerTypeId: this.influencerTypeId,
        segmentId: this.selectedSegment
      },
      queryParamsHandling: 'merge'
    });

    this.getImpressions(undefined, undefined, undefined, undefined);
  }*/

  modeSelected(event) {
    this.mode = event ? event.value : null;
    this.refreshData = true;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        mode: this.mode
      },
      queryParamsHandling: 'merge'
    });
    this.getImpressions(undefined, undefined, undefined, undefined);
  }

  showData(referralIds) {
    this.referralBy = referralIds.name;
    this.referralIds = referralIds.id;
    this.selectedSocialNetwork = null;
    this.getImpressions('influencers', undefined, undefined, '');
    this.socialShareString = referralIds?.socialShareString || '';
  }

  ngAfterViewInit() {
    this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute('referral-influencer-id')) {
        this.showData(event.target.getAttribute('referral-influencer-id'));
        // A document listener, not a template event.
        this.cdr.markForCheck();
      }
    });
  }

  private getChartTextColor(): string {
    return document.body.classList.contains('dark-theme') ? '#e5e7eb' : '#373d3f';
  }

  private getChartSecondaryColor(): string {
    return document.body.classList.contains('dark-theme') ? '#9ca3af' : '#666666';
  }

  getSessionTitle(influencer) {
    return influencer?.sessions?.map(item => item.title).join(' | ') || '';
  }

  /**
   * The table asks for the report: everything the first time for a project, then only the
   * advocates. A fresh table for each project, as the old one was re-created.
   */
  private restartTable(): void {
    this.firstTime = true;
    if (!this.tableStarted()) {
      this.tableStarted.set(true);
      return;
    }
    this.tableStarted.set(false);
    setTimeout(() => this.tableStarted.set(true));
  }

  /** The table asks for a page: the request the old table's ajax made, sorted by the column clicked. */
  onTableState(state: SbTableServerState): void {
    const sections = !this.firstTime ? 'influencers' : undefined;
    const sorted = state.sort && this.tableColumns.find((col) => col.id === state.sort.columnId && col.sortable !== false);
    const orderBy = sorted
      ? {column: sorted.sortKey || sorted.id, dir: state.sort.direction}
      : {column: 'referred_count', dir: 'desc'};
    this.getImpressions(sections, state.page - 1, state.pageLength, state.search, orderBy);
  }

  /** A click anywhere on an advocate's row opens their details, as the row did. */
  onAdvocateRowClick(event: Event): void {
    const tr = (event.target as HTMLElement)?.closest?.('tbody tr[data-row-id]');
    const influencer = tr && this.influencersList().find((item) => String(item.id) === tr.getAttribute('data-row-id'));
    if (influencer) {
      this.showData(influencer);
      this.selectedFromList = influencer;
      this.hideTableState();
    }
  }

  /** The share networks of the Advanced columns, in their order. */
  private static readonly SHARE_NETWORKS = ['linkedin', 'twitter', 'email', 'facebook', 'facebook_messenger', 'instagram', 'slack', 'whatsapp', 'line',
    'microsoft_teams', 'sms', 'zalo', 'wechat', 'bluesky', 'telegram', 'signal', 'tiktok', 'vk', 'viber'];
  readonly shareNetworks = ReportComponent.SHARE_NETWORKS;

  /**
   * One column per old header, hidden the way the old cells were: the Advanced ones unless
   * Advanced is on, and those a chosen influencer type has no such field for.
   */
  private buildTableColumns(): ReportTableColumn[] {
    const self = this;
    const advanced = () => !self.showAllColumns;
    const typeField = (field: string) => () => !self.showAllColumns
      || !(!self.influencerTypeId || (self.influencerTypeId && self.influencerTypesById[self.influencerTypeId][field]));
    // The report sorts its advocates by the column's id, or by `sortKey` where it knows the column by
    // another name; a null `sortKey` is a column it has nothing to sort by.
    const descFirst: Array<'asc' | 'desc'> = ['desc', 'asc'];
    const column = (id: string, header: string, hidden: (() => boolean) | null = null, field?: string,
      sortKey: string | null = id): ReportTableColumn => ({
      id,
      header,
      ...(field ? {field} : {}),
      ...(sortKey === null ? {sortable: false} : {orderSequence: [...descFirst]}),
      ...(sortKey && sortKey !== id ? {sortKey} : {}),
      get hidden() {
        return !!hidden && hidden();
      },
    });
    const shareHeaders = ['LinkedIn', 'X', 'Email', 'Facebook', 'Facebook Messenger', 'Instagram', 'Slack', 'WhatsApp', 'LINE',
      'Microsoft Teams', 'SMS', 'Zalo', 'WeChat', 'Bluesky', 'Telegram', 'Signal', 'TikTok', 'VK (Vkontakte)', 'Viber'];
    return [
      // As narrow as the auto-sized table lets it be: as wide as its content.
      {...column('name', 'Name'), width: '1%'},
      column('referred_count', 'Conversion'),
      column('pageViews', 'Landing Page Impression', null, 'pageViews'),
      column('registrationClicks', 'CTA Clicks', null, 'registrationClicks'),
      column('socialShare', 'Social Shares', null, 'socialShare'),
      column('company', 'Company', advanced, 'company'),
      column('segment', 'Segment', advanced, 'segment'),
      column('emailOpenStatus', 'Email Opened', typeField('updated_at')),
      column('emailClickStatus', 'Email Clicked', typeField('updated_at')),
      // A network's shares are counted in the report's totals, not in its advocate list: no sorting by them.
      ...ReportComponent.SHARE_NETWORKS.map((network, i) => column(`share_${network}`, `${shareHeaders[i]} Share`, typeField('updated_at'), undefined, null)),
      column('source', 'Source', typeField('source')),
      // The url is made from the advocate's campaign codes after the query, so it sorts by those.
      column('campaign_influencer_share_page_url', 'share page url', typeField('updated_at'), 'campaign_influencer_share_page_url', 'campaignInfluencerCodes'),
      column('referredThroughTrackerSource', 'Referral Tracker', typeField('updated_at')),
      column('created_at', 'Create Time', typeField('created_at')),
      column('updated_at', 'Update Time', typeField('updated_at')),
      column('typeName', 'Influencer Type', typeField('typeName'), 'typeName'),
      column('email', 'Email', typeField('email'), 'email'),
      column('booth_number', 'Booth Number', typeField('booth_number'), 'booth_number'),
      ...[['first_name', 'First Name'], ['last_name', 'Last Name'], ['job_title', 'Job Title'], ['phone', 'Phone'],
        ['registration_url', 'Registration url']].map(([field, header]) => column(field, header, typeField(field), field)),
      // A JSON list, which MySQL does not sort.
      column('sessions', 'Sessions', typeField('sessions'), undefined, null),
      ...[['slug', 'Slug'], ['video_url', 'Video url'], ['promo_code', 'Promo Code']].map(([field, header]) => column(field, header, typeField(field), field)),
      column('badge_image_url', 'Badge Image Url', typeField('badge_image_url')),
      column('platform_unique_id', 'Platform Unique Id', typeField('platform_unique_id'), 'platform_unique_id'),
      ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => column(`custom_${n}`, `Custom ${n}`, typeField(`custom_${n}`), `custom_${n}`)),
    ];
  }

  getInfluencerName(influencer) {
    if (influencer.company) {
      return influencer.company;
    } else {
      return `${influencer.first_name} ${influencer.last_name}`;
    }
  }

  getSocialCount(id, platform) {
    return this.reportTotals?.InfluencerSocialNetworksCount[`${id}-${platform}`] || 0;
  }

  // formatData(data: any) {
  //   return (data || []).map(item => {
  //     const action = item.action_value.replace("Share to ", "").replace("Share via ", ""); // Extract platform
  //     const createdAt = this._moment(item.created_at);
  //     const formattedDate = createdAt.format('YYYY/MM/DD HH:mm'); // Format date and time
  //
  //     return `${action} at ${formattedDate}`;
  //   }).join(' | ');
  // }
  //
  // getSocialData(id) {
  //   let socialShareData = this.reportTotals?.socialSharesData.filter(item => item.influencer_id === id)
  //   this.socialShareString = this.formatData(socialShareData)
  // }

  getImpressions(sections = 'influencers,totals,referrals,pageViews', pageNumber = 0, pageLength = 10,
    search = '', orderBy = {column: 'referred_count', dir: 'desc'}, exportAdvocates = false, exportType = 'csv') {
    const params = {
      ...(this.campaignId && this.campaignId > 0 ? {campaignId: this.campaignId} : {}),
      ...(this.influencerTypeId && this.influencerTypeId.length ? {influencerTypeId: JSON.stringify(this.influencerTypeId)} : {}),
      ...(this.selectedSegment && this.selectedSegment.length ? {segmentId: JSON.stringify(this.selectedSegment)} : {}),
      ...(this.startDate ? {startDate: moment(this.startDate).format('YYYY-MM-DD')} : {}),
      ...(this.endDate ? {endDate: moment(this.endDate).format('YYYY-MM-DD')} : {}),
      ...(this.uniqueImportString && exportAdvocates ? {uniqueImportString: this.uniqueImportString} : {}),
      ...(exportAdvocates ? {v1: (new Date()).getTime()} : {}),
      influencers: JSON.stringify({
        page: pageNumber + 1,
        perPage: pageLength,
        ...(this.referralIds ? {referredById: this.referralIds} : {}),
        keywords: search,
        ...(this.selectedSocialNetwork ? { socialNetwork: this.selectedSocialNetwork} : {}),
        ...(this.selectedSegment ? {typeId: this.selectedSegment} : {}),
      }),
      pageViews: JSON.stringify({
        dateFrom: this.startDate,
        dateTo: this.endDate,
      }),
      options: JSON.stringify({
        ...(exportAdvocates ? {skipPagination: true} : {}),
        sections,
        ...(this.mode ? {mode: this.mode} : {}),
        ...(exportAdvocates ? {advanced: this.showAllColumns} : {}),
        orderBy
      }),
      ...(exportAdvocates ? {exportType} : {}),
    };
    if (exportAdvocates) {
      return this.reportStore.dispatch(ReportAdvocatesExport({projectId: this.projectId, params}));
    } else {
      this.reportStore.dispatch(Report({projectId: this.projectId, params}));
    }
  }

  exportAdvocatesData(exportType) {
    this.exportRequesterType = 'project_report_advocates_export';
    this.exportJobId = null;
    this.uniqueImportString = (new Date().getTime()).toString(36);

    this.exportProcess = false;
    if (!['finished', 'failed'].includes(this.exportProgress().status)) {
      this.csvDownloadComplete.set(false);
    }
    if (!this.csvDownloadComplete()) {
      this.setExportProgress({status: 'started', progress: '0'});
    }

    this.getImpressions('influencers', null, null, null, null, true, exportType);

    this.exportModelRef = this._modalService.open(this.csvDownload(), {
      centered: true,
      size: 'md',
      keyboard: true,
    });
    this.exportModelRef.result.then((result) => {
    }, (reason) => {
    });
  }

  /** The Conversions tab's time-to-register filter, kept in the address like the report's other filters. */
  timeToRegisterSelected(seconds: number | null) {
    this.timeToRegisterLt = seconds;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {timeToRegisterLt: seconds || null},
      queryParamsHandling: 'merge'
    });
  }

  onReportTabChange(tab: string) {
    this.activeReportTab = tab;
    if (tab === 'charts') {
      // Drawn while hidden, the charts and the advocate table measured nothing.
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }

  exportConversionsData(request: {exportType: string; params: any}) {
    this.exportRequesterType = 'project_report_conversions_export';
    this.exportJobId = null;
    this.uniqueImportString = (new Date().getTime()).toString(36);

    this.exportProcess = false;
    this.csvDownloadComplete.set(false);
    this.setExportProgress({status: 'started', progress: '0'});

    this.impressionService.exportConversionsReport(this.projectId, {
      ...request.params,
      exportType: request.exportType,
      uniqueImportString: this.uniqueImportString,
      v1: (new Date()).getTime()
    }).subscribe({
      error: (err) => {
        this.setExportProgress({status: 'failed'});
        this.toastr.error(err?.error?.message || 'Export failed. Please try again.', 'Error');
      }
    });

    this.exportModelRef = this._modalService.open(this.csvDownload(), {
      centered: true,
      size: 'md',
      keyboard: true,
    });
    this.exportModelRef.result.then(() => {}, () => {});
  }

  getDate(date: any) {
    if (!date) {
      return;
    }
    const parsed = moment(date);
    if (!parsed.isValid()) {
      return;
    }
    return parsed.toDate();
  }

  generateConversionsGraph() {
    if (this.conversions && this.reportTotals) {
      const dates = this.chartDays(this.conversions);
      const series = [];

      // One line per segment of the pie beside it, in its order and colours, so a segment reads the
      // same in both and none is left out.
      (this.reportTotals.conversionsBySegment || []).forEach((item, index) => {
        const dataByDate = {};
        this.conversions.filter(view => (view.dim4 ?? null) === item.id).forEach(x => {
          dataByDate[moment(x.dim2, 'YYYY-MM-DD').format('DD-MM-YYYY')] = x.dim1;
        });

        const data = [];
        dates.forEach(each => {
          data.push(dataByDate[each] || 0);
        });

        series.push({
          color: this.conversionsColor(index),
          // The chart writes its legend and tooltip as HTML, and these names are typed in by users.
          name: `${escapeHtmlText(this.segmentPieLabel(item))} (${data.reduce((a, b) => a + b, 0)})`,
          data
        });
      });
      this.conversionsGraph.dataLabels = {enabled: false};
      this.conversionsGraph.tooltip = {
        enabled: true,
        shared: true,
        theme: document.body.classList.contains('dark-theme') ? 'dark' : 'light',
        y: {
          formatter: undefined,
          title: {
            // The legend's total comes off: the tooltip shows the day's count.
            formatter: (y) => y.replace(/ \(\d+\)$/, ''),
          },
        }
      };
      this.conversionsGraph.series = series;
      this.conversionsGraph.yaxis = {
        type: '',
        show: true,
        showAlways: true,
        labels: {
          style: {
            colors: this.getChartSecondaryColor()
          }
        },
        title: {
          text: 'Referrals',
          style: {
            color: this.getChartTextColor()
          }
        }
      };
      this.conversionsGraph.xaxis = {
        show: false,
        type: 'category',
        title: {text: 'Dates', style: {
          cssClass: 'report-barchart-title'
        }},
        labels: {
          show: true,
          style: {
            colors: this.getChartSecondaryColor()
          }
        },
        tickAmount: 15,
        categories: dates,
        axisTicks: {
          show: true,
          borderType: 'solid',
          color: '#78909C',
          height: 6,
          offsetX: 0,
          offsetY: 0
        }
      };
    }
  }

  getSeries() {
    const series = [];
    let dates = [];
    if (this.reportTotals && this.pageViews) {
      dates = this.chartDays(this.pageViews);

      // One line per segment that has page views, also one with no contacts left or none recorded,
      // the most viewed first.
      const segments = new Map<number | null, any[]>();
      this.pageViews.forEach(view => {
        const id = view.dim4 ?? null;
        segments.set(id, [...(segments.get(id) || []), view]);
      });
      const totalOf = (views: any[]) => views.reduce((sum, view) => sum + view.dim1, 0);
      [...segments.values()].sort((a, b) => totalOf(b) - totalOf(a)).forEach((views, index) => {
        const dataByDate = {};
        views.forEach(x => {
          dataByDate[moment(x.dim2, 'YYYY-MM-DD').format('DD-MM-YYYY')] = x.dim1;
        });

        const {dim3: name, dim4: id, dim5: type} = views[0];
        series.push({
          color: this.conversionsColor(index),
          // The chart writes its legend and tooltip as HTML, and these names are typed in by users.
          name: escapeHtmlText(this.segmentPieLabel({id: id ?? null, name, type, conversions: 0})),
          data: dates.map(each => dataByDate[each] || 0)
        });
      });
    }
    this.dates = dates;
    this.series = series;
  }

  // Every day from the first row's to the last's, so that a gap in the activity shows on the axis.
  private chartDays(rows: {dim2: string}[]): string[] {
    if (!rows.length) {
      return [];
    }
    const times = rows.map(row => moment(row.dim2, 'YYYY-MM-DD').valueOf());
    const last = moment(Math.max(...times));
    const days = [];
    for (const day = moment(Math.min(...times)); !day.isAfter(last, 'day'); day.add(1, 'day')) {
      days.push(day.format('DD-MM-YYYY'));
    }
    return days;
  }

  zoomOut() {
    this.scaleFactor = 0.1;
    const zoomOutOptions = {
      scale: 1.0,
      offset: {x: 0, y: 0},
      animation: true
    };
    this.networkGraph.fit({animation: zoomOutOptions});
  }

  zoomIn() {
    if (this.scaleFactor < 1) {
      this.scaleFactor += 0.1;
      const zoomInOptions = {
        position: {x: 0, y: 0},
        scale: this.scaleFactor,
        offset: {x: 0, y: 0},
        animation: true
      };
      this.networkGraph.moveTo(zoomInOptions);
    }
  }

  getImageOrIconForGraph(image, typeName, size = 30) {
    if (image) {
      return {
        shape: typeName === 'campaigns' ? 'image' : 'circularImage',
        // shape: 'circularImage',
        image,
        type: typeName,
        brokenImage: 'assets/images/snowflake.png',
        size,
      };
    }
    return {
      shape: 'icon',
      type: typeName,
      icon: {
        face: 'FontAwesome',
        code: '\uf2dc',
        size,
        ...(typeName ? {color: this.groupTypeColor[typeName.toLowerCase()]} : {}),
      }
    };
  }

  createDataTree(dataset) {
    const singles = {};
    dataset.forEach(item => singles[item.id] = {...item, referredTo: []});
    const dataTree = [];
    dataset.forEach(item => {
      if (item.parentId) {
        singles[item.parentId].referredTo.push(singles[item.id]);
      } else {
        dataTree.push(singles[item.id]);
      }
    });
    return dataTree;
  }

  generateNetworkGraph(referrals) {
    if (referrals?.length) {
      document.getElementById('loadingBar').style.opacity = '1';
      document.getElementById('loadingBar').style.display = 'block';
    } else {
      document.getElementById('loadingBar').style.opacity = '0';
      document.getElementById('loadingBar').style.display = 'none';
    }
    const nodes = [];
    const edges = [];
    const parentWithChild = {};
    const referByMediaById = {};
    const mediaIcons = {
      mail: '\uf0e0',
      slack: '\uf198',
      whatsapp: '\uf232',
      linkedin: '\uf0e1',
      twitter: '\uf099',
      facebook: '\uf09a',
      google: '\uf1a0',
      instagram: '\uf16d'
    };

    const getMediaIcon = (type, size) => {
      const exist = Object.keys(mediaIcons).find(x => type.toLowerCase().includes(x));
      return {
        shape: 'icon',
        type: exist,
        icon: {
          face: 'FontAwesome',
          code: exist ? mediaIcons[exist] : '\uf2dc',
          size,
          color: this.socialNetworkColors[exist] || '#4ab8e3',
        }
      };
    };

    const headNodes = {};
    referrals.forEach(item => {
      if (item.referredByMedia) {
        referByMediaById[item.id] = item.referredByMedia;
      }
      headNodes[item.id] = (this.campaignId && this.campaignId > 0 ? this.campaignId : null) || item.campaign_id;
      if (!parentWithChild[item.id]) {
        parentWithChild[item.id] = {
          id: item.id,
          parentId: item.referredBy?.id || null,
        };
      } else if (parentWithChild[item.id] && !parentWithChild[item.id].parentId && item.referredBy) {
        parentWithChild[item.id].parentId = item.referredBy.id;
      }
      if (item.referredBy) {
        headNodes[item.referredBy.id] = (this.campaignId && this.campaignId > 0 ? this.campaignId : null) || item.campaign_id;
        if (item.referredBy.referredByMedia) {
          referByMediaById[item.referredBy.id] = item.referredBy.referredByMedia;
        }
        if (!parentWithChild[item.referredBy.id]) {
          parentWithChild[item.referredBy.id] = {
            id: item.referredBy.id,
            parentId: item.referredBy?.referredBy?.id || null,
          };
        }
      }
    });

    const depthCountById = {};

    const tree = this.createDataTree(Object.values(parentWithChild));


    const fillDepthCount = (dataArray, ids = []) => {
      dataArray.forEach(item => {
        if (!depthCountById[item.id]) {
          depthCountById[item.id] = (item.referredTo || []).length;
        }

        ids.forEach(id => {
          if (!depthCountById[id]) {
            depthCountById[id] = 0;
          }
          depthCountById[id] += (item.referredTo || []).length;
        });

        if ((item.referredTo || []).length > 0) {
          fillDepthCount(item.referredTo, [item.id, ...ids]);
        }
      });
    };

    fillDepthCount(tree);

    const minNodeSize = 45;
    const maxCount = Math.max(...(Object.values(depthCountById) as number[]));
    const mediaSize = 40;
    const campaignSize = minNodeSize + (maxCount * 5) + 10;
    const projectSize = minNodeSize + (maxCount * 5) + 15;
    const existMediaNode = {};

    const getEdgeMedia = (val) => {
      const exist = Object.keys(mediaIcons).find(x => val.toLowerCase().includes(x));
      return exist ? {
        label: mediaIcons[exist],
        ...(this.socialNetworkColors[exist] ? {font: {color: this.socialNetworkColors[exist], oldColor: this.socialNetworkColors[exist], size: mediaSize}} : {})
      } : {label: val};
    };

    // if (this.selectedProject && !this.campaignId) {
    //   nodes.push({
    //     id: `project-${this.selectedProject.id}`,
    //     ...this.getImageOrIconForGraph(this.selectedProject.image, null, projectSize),
    //     label: (this.selectedProject.title),
    //   });
    // }
    const pushedEdges = {};
    // this.campaigns.forEach(item => {
    //   if (this.campaignId) {
    //     if (item.id === this.campaignId) {
    //       nodes.push({
    //         id: `campaign-${item.id}`,
    //         ...this.getImageOrIconForGraph('assets/images/campaign-new.png', 'campaigns', campaignSize),
    //         label: (item.name || ''),
    //       });
    //       // if (this.selectedProject) {
    //       //   edges.push({from: `project-${this.selectedProject.id}`, to: `campaign-${item.id}`, arrows: 'to'});
    //       // }
    //     }
    //   } else {
    //     nodes.push({
    //       id: `campaign-${item.id}`,
    //       ...this.getImageOrIconForGraph('assets/images/campaign-new.png', 'campaigns', campaignSize),
    //       label: (item.name || ''),
    //     });
    //     if (this.selectedProject) {
    //       edges.push({from: `project-${this.selectedProject.id}`, to: `campaign-${item.id}`, arrows: 'to'});
    //     }
    //   }
    // });


    const isItemPushed = {};
    referrals.forEach(item => {
      // let size = ((depthCountById[item.id] || 0) * 100 / maxCount) + minNodeSize;
      let size = ((depthCountById[item.id] || 0) * 5) + minNodeSize;
      if (!isItemPushed[item.id]) {
        nodes.push({
          id: item.id,
          ...this.getImageOrIconForGraph(item.image, item.typeName, size),
          // label: item.id + ' - ' + (item.name || '') + ' - ' + (depthCountById[item.id] || 0),
          label: (item.name || ''),
        });
        isItemPushed[item.id] = true;
      }

      if (item.referredBy) {
        if (!isItemPushed[item.referredBy.id]) {
          // size = ((depthCountById[item.referredBy.id] || 0) * 100 / maxCount) + minNodeSize;
          size = ((depthCountById[item.referredBy.id] || 0) * 5) + minNodeSize;
          nodes.push({
            id: item.referredBy.id,
            ...this.getImageOrIconForGraph(item.referredBy.image, item.referredBy.typeName, size),
            // label: item.referredBy.id + ' - ' + (item.referredBy.name || '') + ' - ' + (depthCountById[item.referredBy.id] || 0)
            label: (item.referredBy.name || '')
          });
          isItemPushed[item.referredBy.id] = true;
        }
        if (referByMediaById[item.id]) {
          /*const mediaNodeId = `${referByMediaById[item.id]}-${item.referredBy.id}`;
          if (!existMediaNode[mediaNodeId]) {
            nodes.push({
              id: mediaNodeId,
              ...getMediaIcon( referByMediaById[item.id], mediaSize),
              label: '',
            });
            edges.push({from: item.referredBy.id, to: mediaNodeId, arrows: 'to'});
            existMediaNode[mediaNodeId] = true;
          }
          edges.push({from: mediaNodeId, to: item.id, arrows: 'to'});*/
          if (!pushedEdges[`${item.referredBy.id}-${item.id}`]) {
            // edges.push({from: item.referredBy.id, to: item.id, arrows: 'to', label: referByMediaById[item.id]});
            edges.push({from: item.referredBy.id, to: item.id, arrows: 'to', ...getEdgeMedia(referByMediaById[item.id])});
            pushedEdges[`${item.referredBy.id}-${item.id}`] = true;
          }
          delete headNodes[item.id];
        } else if (item.referredBy.id !== item.id) {
          delete headNodes[item.id];
          if (!pushedEdges[`${item.referredBy.id}-${item.id}`]) {
            edges.push({from: item.referredBy.id, to: item.id, arrows: 'to'});
            pushedEdges[`${item.referredBy.id}-${item.id}`] = true;
          }
        }
      }
    });
    // Object.keys(headNodes).forEach(item => {
    //   if (referByMediaById[item]) {
    //     // const mediaNodeId = `${referByMediaById[item]}-campaign-${headNodes[item]}`;
    //     //
    //     // if (!existMediaNode[mediaNodeId]) {
    //     //   nodes.push({
    //     //     id: mediaNodeId,
    //     //     ...getMediaIcon( referByMediaById[item], mediaSize),
    //     //     label: '',
    //     //   });
    //     //   edges.push({from: `campaign-${headNodes[item]}`, to: mediaNodeId, arrows: 'to'});
    //     //   existMediaNode[mediaNodeId] = true;
    //     // }
    //     // edges.push({from: mediaNodeId, to: item, arrows: 'to'});
    //     // edges.push({from: `campaign-${headNodes[item]}`, to: item, arrows: 'to', label: referByMediaById[item]});
    //     edges.push({from: `campaign-${headNodes[item]}`, to: item, arrows: 'to', ...getEdgeMedia(referByMediaById[item])});
    //   } else {
    //     edges.push({from: `campaign-${headNodes[item]}`, to: item, arrows: 'to'});
    //   }
    // });
    // edges = [{from: 2, to: 8, arrows: "to"}];
    const container = document.getElementById('mynetwork');
    const data = {
      nodes: new vis.DataSet(nodes),
      edges: new vis.DataSet(edges),
    };
    const options: any = {
      nodes: {
        font: {
          size: 15,
          color: '#000'
        },
        borderWidth: 2,
        shadow: false,
        shapeProperties: {
          interpolation: false
        }
      },
      edges: {
        length: 200,
        width: 1.5,
        font: {
          face: 'FontAwesome',
        },
        smooth: {
          // enabled: false,
          // type: 'continuous'
        },
        color: '#4ab8e3',
        // color: { inherit: 'from' },
      },
      physics: {
        forceAtlas2Based: {
          gravitationalConstant: -1000,
          centralGravity: 0.05,
          springLength: 300,
          springConstant: 0.18,
          avoidOverlap: 1
        },
        maxVelocity: 146,
        solver: 'forceAtlas2Based',
        timestep: 0.35,
        stabilization: {
          enabled: true,
          iterations: 1000,
          updateInterval: 25
        }
      },
      // physics: {
      //   adaptiveTimestep: true,
      //   barnesHut: {
      //     gravitationalConstant: -8000,
      //     springConstant: 0.04,
      //     // springLength: 300
      //   },
      //   // stabilization: {
      //   //   iterations: 987
      //   // }
      // },
      layout: {
        randomSeed: 191006,
        improvedLayout: false
      }
    };
    this.networkGraph = new vis.Network(container, data, options);
    this.networkGraph.on('stabilizationIterationsDone', () => {
      this.networkGraph.setOptions( { physics: false } );
    });
    // this.networkGraph.on('click', (params) => {
    //   const nodeId = params.nodes[0];
    //   if (nodeId) {
    //     const moveToOptions = {
    //       scale: 1.0,
    //       offset: {x: 0, y: 0},
    //       animation: {
    //         duration: 1000,
    //         easingFunction: 'easeInOutQuad'
    //       }
    //     };
    //     this.networkGraph.focus(nodeId, moveToOptions);
    //   }
    // });
    const getColorFromType = (type) => type ? (this.groupTypeColor[type.toLowerCase()] || this.socialNetworkColors[type.toLowerCase()] || '#4ab8e3') : '#4ab8e3';
    const getParentEdge = (nodeId) => data.edges.get({
      fields: ['from', 'id'],
      filter: (item) => item.to.toString() === nodeId.toString()
    });
    const getParentNode = (nodeId) => {
      const result = getParentEdge(nodeId);

      const parentIds = result.map(function(item) {
        return item.from;
      });

      if (parentIds.length) {
        const parentNode = data.nodes.get(parentIds);
        return parentNode.length ? parentNode[0] : null;
      }
      return null;
    };
    const maxParentDepth = 30;
    this.networkGraph.on('stabilizationProgress', (params) => {
      const widthFactor = params.iterations / params.total;

      document.getElementById('bar').style.width = Math.round(widthFactor * 100) + '%';
      document.getElementById('text').innerText =
        Math.round(widthFactor * 100) + '%';
    });
    this.networkGraph.once('stabilizationIterationsDone', () => {
      document.getElementById('text').innerText = '100%';
      document.getElementById('bar').style.width = '100%';
      document.getElementById('loadingBar').style.opacity = '0';
      // really clean the dom element
      setTimeout( () => {
        document.getElementById('loadingBar').style.display = 'none';
      }, 500);
    });
    const allNodes = data.nodes.get({ returnType: 'Object' });
    const allEdges = data.edges.get({ returnType: 'Object' });
    let highlightActive = false;
    this.networkGraph.on('click', (params) => {
      const newOptions = {...options, physics: false};
      if (params.nodes.length > 0) {
        newOptions.edges.color = 'rgba(200,200,200,0.5)';

        highlightActive = true;
        let i;
        const selectedNode = params.nodes[0];

        for (const key of Object.keys(allEdges)) {
          allEdges[key].color = 'rgba(200,200,200,0.5)';
          if (allEdges[key].label && allEdges[key].font) {
            allEdges[key].font.color = 'rgba(200,200,200,0.5)';
          }
        }

        for (const nodeId of Object.keys(allNodes)) {
          allNodes[nodeId].color = 'rgba(200,200,200,0.5)';
          if (allNodes[nodeId].icon) {
            allNodes[nodeId].icon.color = 'rgba(200,200,200,0.5)';
          }
          if (allNodes[nodeId].hiddenLabel === undefined) {
            allNodes[nodeId].hiddenLabel = allNodes[nodeId].label;
            allNodes[nodeId].label = undefined;
          }
        }
        let connectedNodes: any = {};
        const connectedEdge = {};
        params.nodes.forEach(item => {
          let parentNode = getParentNode(item);
          let parentEdge = getParentEdge(item);
          let depth = 1;
          while (!!parentNode && depth <= maxParentDepth) {
            connectedNodes[parentNode.id] = parentNode;

            if (parentEdge.length) {
              connectedEdge[parentEdge[0].id] = parentEdge[0];
            }

            if (parentNode) {
              parentEdge = getParentEdge(parentNode.id);
            }

            parentNode = getParentNode(parentNode.id);

            depth++;
          }
        });
        connectedNodes = Object.keys(connectedNodes);

        for (const key of Object.keys(connectedEdge)) {
          allEdges[key].color = '#4ab8e3';
          if (allEdges[key].label && allEdges[key].font) {
            allEdges[key].font.color = allEdges[key].font?.oldColor || '#333333';
          }
        }

        // all first degree nodes get their own color and their label back
        for (i = 0; i < connectedNodes.length; i++) {
          allNodes[connectedNodes[i]].color = getColorFromType(allNodes[connectedNodes[i]].type);
          if (allNodes[connectedNodes[i]].icon) {
            allNodes[connectedNodes[i]].icon.color = getColorFromType(allNodes[connectedNodes[i]].type);
          }
          if (allNodes[connectedNodes[i]].hiddenLabel !== undefined) {
            allNodes[connectedNodes[i]].label =
              allNodes[connectedNodes[i]].hiddenLabel;
            allNodes[connectedNodes[i]].hiddenLabel = undefined;
          }
        }

        // the main node gets its own color and its label back.
        allNodes[selectedNode].color = getColorFromType(allNodes[selectedNode].type);
        if (allNodes[selectedNode].icon) {
          allNodes[selectedNode].icon.color = getColorFromType(allNodes[selectedNode].type);
        }
        if (allNodes[selectedNode].hiddenLabel !== undefined) {
          allNodes[selectedNode].label = allNodes[selectedNode].hiddenLabel;
          allNodes[selectedNode].hiddenLabel = undefined;
        }
      } else if (highlightActive === true) {
        newOptions.edges.color = '#4ab8e3';

        for (const nodeId of Object.keys(allNodes)) {
          allNodes[nodeId].color = getColorFromType(allNodes[nodeId].type);
          if (allNodes[nodeId].icon) {
            allNodes[nodeId].icon.color = getColorFromType(allNodes[nodeId].type);
          }
          if (allNodes[nodeId].hiddenLabel !== undefined) {
            allNodes[nodeId].label = allNodes[nodeId].hiddenLabel;
            allNodes[nodeId].hiddenLabel = undefined;
          }
        }

        for (const key of Object.keys(allEdges)) {
          allEdges[key].color = '#4ab8e3';
          if (allEdges[key].label && allEdges[key].font) {
            // const getMediaObj = getEdgeMedia(allEdges[key].label);
            allEdges[key].font.color = allEdges[key].font?.oldColor || '#333333';
          }
        }
        highlightActive = false;
      }

      // transform the object into an array
      const updateArray = [];
      const edgeArray = [];
      for (const nodeId in allNodes) {
        if (allNodes.hasOwnProperty(nodeId)) {
          if (allNodes[nodeId].color !== this.groupTypeColor.campaigns && allNodes[nodeId].type === 'campaigns') {
            allNodes[nodeId].image = 'assets/images/campaign-disabled-new.png';
          } else if (allNodes[nodeId].color === this.groupTypeColor.campaigns && allNodes[nodeId].type === 'campaigns') {
            allNodes[nodeId].image = 'assets/images/campaign-new.png';
          }
          updateArray.push(allNodes[nodeId]);
        }
      }

      for (const edgeId in allEdges) {
        if (allEdges.hasOwnProperty(edgeId)) {
          edgeArray.push(allEdges[edgeId]);
        }
      }
      this.networkGraph.setOptions(newOptions);
      data.nodes.update(updateArray);
      data.edges.update(edgeArray);
    });
  }

  getFormattedDate(date) {
    return new Date(moment(date, 'DD-MM-YYYY').format('MM/DD/YYYY'));
  }

  getLastSyncFormattedDate(date) {
    return moment(date).format('YYYY-MM-DD hh:mm a');
  }

  setDate(date: Date, type: string, forceClear = false) {
    if (!this.justSetDate) {
      const secondType = type === 'startDate' ? 'endDate' : 'startDate';
      if (date) {
        this.isStartDateNull = false;
        this.isEndDateNull = false;
        this[type] = moment(date).format('YYYY-MM-DD');
        if (!this[secondType]) {
          this[secondType] = moment(date).format('YYYY-MM-DD');
        }
        this.navigateDates({
          ...(this[secondType] ? {[secondType]: this[secondType]} : {}),
          [type]: this[type]
        });
        this.getImpressions(undefined, undefined, undefined, undefined);
      } else {
        if (forceClear) {
          if(type === 'startDate') {
            this.isStartDateNull = true;
          }
          if(type === 'endDate') {
            this.isEndDateNull = true;
          }

          this[type] = null;
          this.navigateDates({[type]: this[type]});
          this.getImpressions(undefined, undefined, undefined, undefined);
        }
      }
    }
  }

  /**
   * A range commit, with `setDate`'s rules in one pass: emptying one side leaves it open, as its
   * clear button did (`forceClear`); a side still empty when the other is picked takes that day;
   * two empty sides clear both. One address change and one load, where two picks made two.
   */
  onRangeChange({start, end}: SbDateRange) {
    if (this.justSetDate) {
      return;
    }
    const emptied = this.startDate && !start && end === this.endDate ? 'startDate'
      : this.endDate && !end && start === this.startDate ? 'endDate'
        : null;
    if (emptied && (start || end)) {
      if (emptied === 'startDate') {
        this.isStartDateNull = true;
      } else {
        this.isEndDateNull = true;
      }
      this[emptied] = null;
      this.navigateDates({[emptied]: null});
      this.getImpressions(undefined, undefined, undefined, undefined);
      return;
    }
    if (!start && !end) {
      this.isStartDateNull = true;
      this.isEndDateNull = true;
      this.startDate = null;
      this.endDate = null;
    } else {
      this.isStartDateNull = false;
      this.isEndDateNull = false;
      this.startDate = start || end;
      this.endDate = end || start;
    }
    this.navigateDates({startDate: this.startDate, endDate: this.endDate});
    this.getImpressions(undefined, undefined, undefined, undefined);
  }

  /** Puts dates in the address, merged with what it names, and notes what it will name. */
  private navigateDates(queryParams: Params) {
    const address = {...this.addressDates, ...queryParams};
    this.ownDates = {startDate: address.startDate ?? null, endDate: address.endDate ?? null};
    this.router.navigate([], {relativeTo: this.activatedRoute, queryParams, queryParamsHandling: 'merge'});
  }

  get reportAccessible(): boolean {
    return !!this.currentUser() || !!this.temporaryToken;
  }

  showPasswordForm() {
    if (this.temporaryToken || this.passwordModalRef) {
      return;
    }
    const ref = this._modalService.open(this.passwordForm(), {
      centered: true,
      size: 'md',
      keyboard: false,
      backdrop: 'static',
      backdropClass: 'sn-report-password-backdrop'
    });
    this.passwordModalRef = ref;
    const forget = () => {
      if (this.passwordModalRef === ref) {
        this.passwordModalRef = null;
      }
    };
    ref.result.then(forget, forget);
  }

  validatePassword(modal: any) {
    if (this.reportPasswordPending()) {
      return;
    }
    this.reportModel = modal;
    if (!this.reportPassword()) {
      this.reportPasswordError.set('Please enter password');
      return;
    }
    this.reportPasswordError.set('');
    this.reportPasswordClick = true;
    this.reportPasswordPending.set(true);
    this.reportStore.dispatch(ReportPassword({projectId: this.projectId, password: this.reportPassword()}));
  }

  generatePieChart() {
    if (this.reportTotals) {
      const socialNetworkCounts = this.reportTotals.socialNetworks;
      const keys = Object.keys(socialNetworkCounts);
      this.piechart.labels = keys.map(item => this.socialNetworkDisplayNames[item.toLowerCase()] || `${item.charAt(0).toUpperCase() + item.slice(1)}`);
      this.piechart.series = Object.values(socialNetworkCounts);
      this.piechart.colors = [];
      keys.forEach((key, index) => {
        const colorKey = key.toLowerCase();
        if (this.socialNetworkColors[colorKey]) {
          this.piechart.colors.push(this.socialNetworkColors[colorKey]);
        } else {
          this.piechart.colors.push(this.generateUniqueColor(index));
        }
      });
      this.piechart.dataLabels = {
        ...this.piechart.dataLabels,
        style: {
          ...this.piechart.dataLabels.style,
          colors: keys.map(() => '#ffffff')
        },
        dropShadow: {
          enabled: false
        }
      };
      this.piechart.chart.events = {
        dataPointSelection: (event, chartContext, config) => {
          let lbl = keys[config.dataPointIndex];
          lbl = (lbl || '').toLowerCase();
          this.selectedSocialNetwork = this.selectedSocialNetwork === lbl ? null : lbl;
          this.getImpressions('influencers', undefined, undefined, '');
        }
      };
      this.piechart.chart.foreColor = this.getChartTextColor();
      this.piechart.tooltip = {
        theme: 'dark',
        style: {
          fontSize: '12px'
        },
        y: {
          formatter: (val) => val
        }
      };
      this.piechart.legend = {
        labels: {
          colors: this.getChartTextColor()
        }
      };
      this.piechart.noData = {
        text: 'No data available.',
        style: {
          color: '#9ca3af'
        }
      };
    }
  }

  generateConversionsPies() {
    this.conversionsBySegmentPie = this.conversionsPie((this.reportTotals?.conversionsBySegment || [])
      .map(row => ({label: this.segmentPieLabel(row), conversions: row.conversions})));
    this.conversionsByCampaignTypePie = this.conversionsPie((this.reportTotals?.conversionsByCampaignType || [])
      .map(row => ({label: row.name || 'No campaign', conversions: row.conversions})));
  }

  // Type.Segment. A project creates each type's default segment as "Default for <type>", which
  // the type in front already says.
  private conversionsColor(index: number): string {
    return this.typeColor[index] || this.generateUniqueColor(index);
  }

  private segmentPieLabel({name, type}: ReportConversionsBySegment): string {
    if (!name) {
      return 'No segment';
    }
    const segment = name.trim().replace(/^Default for .*/i, 'Default');
    return type ? `${type}.${segment}` : segment;
  }

  private conversionsPie(rows: {label: string, conversions: number}[]) {
    const total = rows.reduce((sum, row) => sum + row.conversions, 0);
    return {
      // The chart writes its legend and tooltip as HTML, and these names are typed in by users.
      labels: rows.map(row => escapeHtmlText(row.label)),
      series: rows.map(row => row.conversions),
      colors: rows.map((_, index) => this.conversionsColor(index)),
      chart: {type: 'pie', height: '450', foreColor: this.getChartTextColor()},
      dataLabels: {
        enabled: true,
        formatter: (val) => `${val.toFixed(1)}%`,
        style: {fontSize: '11px', fontFamily: 'Helvetica', colors: rows.map(() => '#ffffff')},
        dropShadow: {enabled: true, top: 0, left: 0, blur: 2, opacity: 0.6}
      },
      tooltip: {theme: 'dark', style: {fontSize: '12px'}, y: {formatter: (val) => val}},
      legend: {
        position: 'bottom',
        labels: {colors: this.getChartTextColor()},
        formatter: (label, opts) => {
          const conversions = opts.w.globals.series[opts.seriesIndex];
          return `${label}: ${conversions} (${(conversions * 100 / total).toFixed(1)}%)`;
        }
      }
    };
  }

  generateShareMediaChart() {
    const {personalized_video: personalizedVideo, ...recorded} = this.reportTotals?.shareMediaTypes || {};
    // The campaign's video and an advocate's own video both count as a video share here.
    const counts = {...recorded, video: (recorded.video || 0) + (personalizedVideo || 0)};
    const media = [
      {key: 'image', label: 'Image', color: '#4AB8E3'},
      {key: 'video', label: 'Video', color: '#6FCF97'},
      {key: 'not_recorded', label: 'Not recorded', color: '#9ca3af'}
    ].filter(item => item.key !== 'not_recorded' || counts[item.key] > 0);
    const total = Object.values(counts).reduce((sum: number, value: number) => sum + (Number(value) || 0), 0) as number;
    const percent = (value) => total ? Number(((value || 0) * 100 / total).toFixed(1)) : 0;
    this.shareMediaRadialBar.series = total ? media.map(item => percent(counts[item.key])) : [];
    this.shareMediaRadialBar.labels = media.map(item => item.label);
    this.shareMediaRadialBar.colors = media.map(item => item.color);
    this.shareMediaRadialBar.plotOptions = {
      radialBar: {
        hollow: {
          margin: 0,
          size: '40%',
        },
        dataLabels: {
          total: {
            show: true,
            label: 'Total Shares',
            formatter() {
              return total;
            }
          },
        }
      }
    };
    this.shareMediaRadialBar.responsive = this.radialBar.responsive;
    this.shareMediaRadialBar.legend = {
      show: true,
      position: 'right',
      labels: {
        colors: this.getChartTextColor()
      },
      markers: {
        width: 7,
        height: 7,
        offsetX: -10
      },
      customLegendItems: media.map(item =>
        `<strong>${item.label}:</strong> ${percent(counts[item.key])}% (${counts[item.key] || 0})`),
      itemMargin: {
        horizontal: 3
      },
      horizontalAlign: 'center',
      fontSize: '12px'
    };
  }

  async renderSharesMap() {
    const counts = this.reportTotals?.sharesByCountry || {};
    this.hasSharesByCountry = Object.keys(counts).length > 0;
    this.destroySharesMap();
    const {default: JsVectorMap} = await import('jsvectormap');
    await import('jsvectormap/dist/maps/world.js');
    const element = this.sharesMapElement()?.nativeElement;
    if (!element || this.reportTotals?.sharesByCountry !== counts) {
      return;
    }
    // A log scale, so one large country does not wash every other one out.
    const values = {};
    Object.keys(counts).forEach(code => values[code] = Math.log10(counts[code] + 1));
    this.sharesMap = new JsVectorMap({
      selector: element,
      map: 'world',
      zoomOnScroll: false,
      regionStyle: {
        initial: {fill: document.body.classList.contains('dark-theme') ? '#4b5563' : '#dee2e8'}
      },
      visualizeData: {
        scale: ['#CDEBF8', '#0A66C2'],
        values
      },
      onRegionTooltipShow: (event, tooltip, code) => {
        tooltip.text(`${tooltip.text()}: ${counts[code] || 0} share${counts[code] === 1 ? '' : 's'}`);
      }
    });
    const regionNames = new Intl.DisplayNames(['en'], {type: 'region'});
    this.sharesNotOnMap = Object.keys(counts)
      .filter(code => !this.sharesMap.regions[code])
      .sort((a, b) => counts[b] - counts[a])
      .map(code => ({name: this.countryName(regionNames, code), count: counts[code]}));
    this.cdr.markForCheck();
    window.removeEventListener('resize', this.onSharesMapResize);
    window.addEventListener('resize', this.onSharesMapResize);
    setTimeout(() => this.sharesMap?.updateSize());
  }

  private countryName(regionNames: Intl.DisplayNames, code: string): string {
    try {
      return regionNames.of(code) || code;
    } catch {
      return code;
    }
  }

  toggleSharesByCountry() {
    this.hideDiv.sharesByCountry = !this.hideDiv.sharesByCountry;
    // Drawn while the card was collapsed, the map has no size until it is shown.
    if (!this.hideDiv.sharesByCountry) {
      setTimeout(() => this.sharesMap?.updateSize());
    }
  }

  private destroySharesMap() {
    this.sharesNotOnMap = [];
    if (this.sharesMap) {
      this.sharesMap.destroy();
      this.sharesMap = null;
    }
    const element = this.sharesMapElement()?.nativeElement;
    if (element) {
      element.innerHTML = '';
    }
  }

  generateUniqueColor(index) {
    const hue = (index * 137.508) % 360;
    return `hsl(${hue}, 70%, 60%)`;
  }

  generatePreferenceInsightsChart() {
    const series = this.reportTotals?.preferenceInsights?.series || [];
    // Real timestamps so the axis is a true datetime axis (required for the campaign
    // launch annotations to anchor at exact launch dates).
    const xs = series.map((s) => moment(s.date).valueOf());
    this.preferenceInsightsChart.categories = series.map((s) => s.date);
    this.preferenceInsightsChart.colors = ['#00A8EC', '#fd7e14', '#dc3545', '#e83e8c', '#6f42c1', '#333399', '#28a745'];
    this.preferenceInsightsChart.series = [
      {name: 'Updated preferences', data: series.map((s, i) => [xs[i], s.updatedPreferences || 0])},
      {name: 'Email frequency', data: series.map((s, i) => [xs[i], s.emailFrequency || 0])},
      {name: 'Marketing email opt-out', data: series.map((s, i) => [xs[i], s.marketingEmailOptOut || 0])},
      {name: 'All email opt-out', data: series.map((s, i) => [xs[i], s.allEmailOptOut || 0])},
      {name: 'No email open tracking', data: series.map((s, i) => [xs[i], s.noEmailOpenTracking || 0])},
      {name: 'No tracking', data: series.map((s, i) => [xs[i], s.noTracking || 0])},
      {name: 'Data removal', data: series.map((s, i) => [xs[i], s.dataRemoval || 0])},
    ];
    // Window the markers to the report's selected date range (falling back to the data
    // span). Campaign launches often precede the first preference activity, so the axis
    // is bounded to this window (below) rather than to the sparse data, so those markers
    // stay visible instead of being clipped off the left edge.
    const windowStart = this.startDate ? moment(this.startDate).startOf('day').valueOf() : (xs.length ? xs[0] : null);
    const windowEnd = this.endDate ? moment(this.endDate).endOf('day').valueOf() : (xs.length ? xs[xs.length - 1] : null);
    // campaignLaunches ships in the same report payload as the series, so it's always
    // present when the chart is built (no dependency on the separately-loaded store).
    const launches = this.reportTotals?.preferenceInsights?.campaignLaunches || [];
    const markers = this.buildCampaignLaunchAnnotations(launches, windowStart, windowEnd);
    this.preferenceInsightsChart.annotations = {xaxis: markers};
    // Bound the axis to the actual content (data points + markers) — not the full report
    // window — so there's no empty stretch after the last data point / last launch.
    if (markers.length && xs.length) {
      const markerTimes = markers.map((m) => m.x);
      this.preferenceInsightsChart.xMin = Math.min(xs[0], ...markerTimes);
      this.preferenceInsightsChart.xMax = Math.max(xs[xs.length - 1], ...markerTimes);
    } else {
      this.preferenceInsightsChart.xMin = null;
      this.preferenceInsightsChart.xMax = null;
    }
  }

  // Vertical markers at each campaign launch, so spikes in the insights chart can be
  // correlated with the campaign that drove them. Same-day launches (segment batches)
  // are grouped into a single marker so the labels stay readable.
  buildCampaignLaunchAnnotations(launches, windowStart, windowEnd) {
    if (windowStart === null || windowEnd === null || !launches?.length) {
      return [];
    }
    const byDay = new Map();
    launches.forEach((c) => {
      const ts = moment(c.launchedAt).valueOf();
      if (isNaN(ts) || ts < windowStart || ts > windowEnd) {
        return;
      }
      const key = moment(c.launchedAt).format('YYYY-MM-DD');
      if (!byDay.has(key)) {
        byDay.set(key, {time: moment(c.launchedAt).startOf('day').valueOf(), names: []});
      }
      byDay.get(key).names.push(c.name);
    });
    const days = Array.from(byDay.values()).sort((a, b) => a.time - b.time);
    // Full (un-ellipsed) label per marker, in the same order — used for the hover title.
    this.preferenceInsightsChart.markerTitles = days.map((d) => d.names.join(', '));
    return days.map(({time, names}, index) => {
      const full = names.join(', ');
      const text = this.showCampaignLaunchLabels
        ? (full.length > 22 ? full.slice(0, 21) + '…' : full)
        : '';
      return {
        x: time,
        strokeDashArray: 4,
        borderColor: '#475569',
        label: {
          text,
          position: 'top',
          orientation: 'horizontal',
          // Stagger adjacent labels onto two rows so close launch days don't collide.
          offsetY: index % 2 === 0 ? 0 : 16,
          borderColor: '#475569',
          style: {
            fontSize: '10px',
            color: '#fff',
            background: '#475569',
            padding: {left: 5, right: 5, top: 2, bottom: 2}
          }
        }
      };
    });
  }

  toggleCampaignLaunchLabels() {
    this.showCampaignLaunchLabels = !this.showCampaignLaunchLabels;
    this.generatePreferenceInsightsChart();
  }

  // ApexCharts has no tooltip for annotation labels, so after each (re)render attach a
  // native SVG <title> carrying the full campaign name(s) — shown on hover over the
  // (possibly ellipsed) label. Arrow fn so `this` stays bound when passed to the chart.
  onPreferenceChartRender = (chartContext?: any) => {
    try {
      const root = chartContext?.el || chartContext?.w?.globals?.dom?.baseEl;
      if (!root) {
        return;
      }
      const titles = this.preferenceInsightsChart.markerTitles || [];
      root.querySelectorAll('.apexcharts-xaxis-annotation-label').forEach((el: any) => {
        const rel = el.getAttribute('rel');
        const idx = rel !== null ? parseInt(rel, 10) : NaN;
        const full = !isNaN(idx) ? titles[idx] : null;
        if (!full) {
          return;
        }
        let title = el.querySelector('title');
        if (!title) {
          title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
          el.appendChild(title);
        }
        title.textContent = full;
        // Annotation labels are pointer-events:none by default — enable so the title shows.
        el.style.pointerEvents = 'all';
        el.style.cursor = 'default';
      });
    } catch (e) {
      // non-fatal — hover titles are a nicety
    }
  };

  get preferenceInsightsDateLabel(): string {
    const from = this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : null;
    const to = this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : null;
    if (from && to) {
      return `${from} – ${to}`;
    }
    if (from) {
      return `from ${from}`;
    }
    if (to) {
      return `until ${to}`;
    }
    return 'last 90 days';
  }

  generateRadialPieChart() {
    if (this.reportTotals) {
      const totalTried = this.reportTotals.emailsOpenRate.total || 0;
      const totalSent = this.reportTotals.emailsOpenRate.sent || 0;
      // const bounce = (this.reportTotals.emailsOpenRate.opened || 0) - (this.reportTotals.emailsOpenRate.clicked || 0); // bounce = open - click
      const bounce = (this.reportTotals.emailsOpenRate.failed || 0);
      const totalData = {
        bounce: {
          label: 'Bounce',
          val: bounce || 0,
          per: totalTried ? Number((bounce || 0) * 100 / totalTried).toFixed(1) : 0,
        },
        optOut: {
          label: 'Data removed',
          val: this.reportTotals.dataRemoved || 0,
          per: totalSent ? Number((this.reportTotals.dataRemoved || 0) * 100 / totalSent).toFixed(1) : 0,
        },
        clickRate: {
          label: 'Click Rate',
          val: this.reportTotals.emailsOpenRate.clicked || 0,
          per: totalSent ? Number((this.reportTotals.emailsOpenRate.clicked || 0) * 100 / totalSent).toFixed(1) : 0,
        },
        openRate: {
          label: 'Open Rate',
          val: this.reportTotals.emailsOpenRate.opened || 0,
          per: totalSent ? Number((this.reportTotals.emailsOpenRate.opened || 0) * 100 / totalSent).toFixed(1) : 0,
        },
      };
      // this.radialBar.series = [totalData.bounce.per, totalData.optOut.per, totalData.clickRate.per, totalData.openRate.per];
      this.radialBar.series = [totalSent, totalData.openRate.per,  totalData.clickRate.per, totalData.bounce.per, totalData.optOut.per,];
      // this.radialBar.stroke = {width: -2};
      this.radialBar.plotOptions = {
        radialBar: {
          hollow: {
            margin: 0,
            size: '40%',
          },
          dataLabels: {
            total: {
              show: true,
              label: 'Total Sent To',
              formatter(w) {
                return totalSent;
              }
            },
          }
        }
      };
      this.radialBar.responsive = [
        {
          breakpoint: 1000,
          options: {
            legend: {
              position: 'top',
              itemMargin: {
                horizontal: 10,
                vertical: 5
              },
              markers: {
                offsetX: -5
              }
            },
            chart: {
              offsetY: 40
            }
          }
        },
        {
          breakpoint: 400,
          options: {
            chart: {
              offsetY: 65
            }
          }
        }
      ];
      this.radialBar.labels = ['Sent To', 'Open Rate', 'Click Rate', 'Bounce Rate', 'Opt-out'];
      this.radialBar.colors = ['#ffffff', '#4AB8E3', '#6FCF97', '#F2994A', '#EB5757'];
      this.radialBar.legend = {
        show: true,
        inverseOrder: false ,
        position: 'right',
        labels: {
          colors: this.getChartTextColor()
        },
        markers:{
          width: 7,
          height: 7,
          offsetX: -10
        },
        customLegendItems: [
          `<strong>Sent To:</strong> ${totalSent}`,
          `<strong>Open Rate:</strong> ${totalData.openRate.per}% (${totalData.openRate.val})`,
          `<strong>Click Rate:</strong> ${totalData.clickRate.per}% (${totalData.clickRate.val})`,
          `<strong>Bounce Rate:</strong> ${totalData.bounce.per}% (${totalData.bounce.val})`,
          `<strong>Data removed:</strong> ${totalData.optOut.per}% (${totalData.optOut.val})`,
        ],
        itemMargin: {
          horizontal: 3
        },
        horizontalAlign: 'center',
        // offsetY: 50,
        fontSize: '12px'
      };
    }
  }

  chartLabelFormatter(val, opts) {
    return [opts.w.config.labels[opts.seriesIndex], val.toFixed(1) + '%'];
  }

  formatInsertTime(insertTime) {
    insertTime = moment(insertTime, 'YYYY-MM-DD[T]HH[:]mm[:]00[.000Z]');
    if (insertTime.isValid()) {
      return insertTime.format('DD-MM-YYYY hh:mm a');
    }
    return '-';
  }

  formatMoment(insertTime) {
    const m = moment(insertTime, 'YYYY-MM-DD[T]HH[:]mm[:]00[.000Z]');
    if (m.isValid()) {
      return m;
    }
    return null;
  }

  dateEvents() {
    this.currentProject = this.projects.find(x => Number(x.id) === Number(this.projectId));
    if (!this.currentProject) {
      return;
    }
    // this.projectStartDate = this.tzDatePipe.toLocalMomentObject(moment(this.currentProject?.start_date)).format(`YYYY-MM-DD${this.currentProject?.start_time ? ' hh:mm A' : ''}`);
    // this.projectEndDate = this.tzDatePipe.toLocalMomentObject(moment(this.currentProject?.end_date)).format(`YYYY-MM-DD${this.currentProject?.end_time ? ' hh:mm A' : ''}`);
    if (this.currentProject?.start_date) {
      const startMoment = this.tzDatePipe.toLocalMomentObject(this.currentProject.start_date);
      this.projectStartDate = startMoment && startMoment.isValid() ? startMoment.format('DD-MM-YYYY') : '';
    }
    if (this.currentProject?.end_date) {
      const endMoment = this.tzDatePipe.toLocalMomentObject(this.currentProject.end_date);
      this.projectEndDate = endMoment && endMoment.isValid() ? endMoment.format('DD-MM-YYYY') : '';
    }
  }

  ngOnDestroy() {
    this.reportStore.dispatch(ResetReportState({params: {report: null, error: '', reportPassword: ''}}));
    this.loadModalReportRef?.dismiss();
    this.loadModalReportRef = null;
    this.passwordModalRef?.dismiss();
    this.passwordModalRef = null;
    this.socketSubscription?.unsubscribe();
    this.networkGraph?.destroy();
    this.destroySharesMap();
    window.removeEventListener('resize', this.onSharesMapResize);
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
  }

  initResize() {
    window.addEventListener('resize', (event) => {
      this.doResize();
    }, true);
  }

  doResize() {
    setTimeout(() => {
      const iflList = document.getElementById('influencer-list');
      if (iflList) {
        if (iflList.offsetWidth < 520 || this.segments?.length > 3) {
          this.forceGroup = true;
        } else {
          this.forceGroup = false;
        }
      }
    });
  }

  hideTableState() {
    this.isTableHide = this.selectedFromList.referredCount === 0;
  }
}
